import React from 'react';
import styles from './FormModal.module.scss';

interface FormModalFooterProps {
    children: React.ReactNode;
}


const FormModalFooter: React.FC<FormModalFooterProps> = ({ children }) => (
    <div className={styles.footer}>{children}</div>
);

export default FormModalFooter;
